import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls window to top whenever the route changes (path or search).
// Honors hash anchors: if a hash is present, leave scroll behavior to the browser.
export default function ScrollToTop() {
    const { pathname, search, hash } = useLocation();

    useEffect(() => {
        if (hash) return;
        // Use 'auto' (instant) so users never see a jarring scroll animation between pages.
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, search, hash]);

    return null;
}
